import { Note } from "../../../helbest";
import { API } from "../../../request/api";

const useAppointment = () => {
  const categories = (setCategoryData, setLoading, setError) => {
    setLoading(true);
    API.get
      .getCategories()
      .then((response) => {
        if (response.code === 200) {
          setCategoryData(response.data);
        } else if (response.code === 403) {
          setError(true);
        } else {
          Note.error(response.message);
        }
      })
      .catch((error) => {
        throw error;
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const appointments = (
    setAppointmentsData,
    selectedCategory,
    setLoading,
    start = null,
    end = null,
    q = "",
    sort,
    setError
  ) => {
    setLoading(true);
    API.get
      .getAppointments(selectedCategory, start, end, q, sort)
      .then((response) => {
        if (response.code === 200) {
          setAppointmentsData(response.data.results);
        } else if (response.code === 403) {
          setError(true);
        } else {
          Note.error(response.message);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const appointmentDetail = (id, setData, setLoading) => {
    setLoading(true);
    API.get
      .getAppointment(id)
      .then((response) => {
        if (response.success) {
          setData(response.data);
        } else {
          Note.error(response.message);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return { categories, appointments, appointmentDetail };
};

export { useAppointment };
